import { Button } from "@/components/Button"
import { Input } from "@/components/Form/Input"
import { Modal } from "@/components/Modal"
import { IBAN, IBANApi, useIBANStore } from "@usher/pe-client-front-end-lib"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"

interface Props {
  show: IBAN | null
  onClose: VoidFunction
  loading?: boolean
}
interface Form {
  title: string
}
export const TitleEditModal = ({ show, onClose }: Props) => {
  const { reset, control, handleSubmit } = useForm<Form>()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (show != null && "id" in show) reset({ title: show.title || "" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])
  const onSubmit = async (data: Form) => {
    setLoading(true)
    try {
      await IBANApi.editTitle(data.title, (show as IBAN).id)
      useIBANStore.getState().fetchList()
      toast.success("Title updated successfully")
      reset({ title: "" })
      onClose()
    } catch {
      toast.error("Failed to update title")
    } finally {
      setLoading(false)
    }
  }
  return (
    <Modal show={Boolean(show)} onClose={onClose} title="Edit IBAN Title" className="w-full sm:w-auto sm:min-w-[450px]">
      <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Input.Form
          name="title"
          control={control}
          label="Title"
          className="mt-3 [&>span:first-of-type]:text-base"
          required
          rules={{
            maxLength: { value: 50, message: "Title must be 50 characters long" },
            validate: (val) => {
              if (val.trim().length === 0) return "Invalid value"
            },
          }}
        />
        <div className="flex gap-2 md:gap-3 child:flex-1 mt-4 flex-col-reverse md:flex-row">
          <Button color="inherit" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Save
          </Button>
        </div>
      </form>
    </Modal>
  )
}
